import { makeStyles } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    textAlign: "center",
  },
  footer: {
    backgroundColor: "black",
    marginTop: "0px",
    textAlign: "center",
    color: "white",
    padding: "20px 0",
  },
  linksBox: {
    marginTop: "40px",
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
  },
  linkItem: {
    color: "black",
    margin: "0 20px",
    textDecoration: "none",
    fontWeight: 600,
    fontSize: 18,
  },
  socialItem: {
    color: "black",
    margin: "0 20px",
    fontWeight: "600",
    fontSize: 22,
  },
}));

const otherLinks = [
  {
    link: "#",
    name: "Music",
  },
  {
    link: "#",
    name: "Publishing",
  },
  {
    link: "#",
    name: "Movies/Videos",
  },
  {
    link: "#",
    name: "Marketing",
  },
];
const socialLinks = [
  {
    link: "https://www.facebook.com",
    icon: <FaFacebookF />,
  },
  {
    link: "https://www.twitter.com",
    icon: <FaTwitter />,
  },
  {
    link: "https://www.instagram.com",
    icon: <FaInstagram />,
  },
  {
    link: "https://www.linkedin.com",
    icon: <FaLinkedinIn />,
  },
];

function Footer() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.footer}>
        Copyright &copy; 2022 - Decade 2 Publishing
      </div>
    </div>
  );
}

export default Footer;
